<template>
    <div>
        <div v-if="loading" class="text-center">
            <i class="fa fa-circle-o-notch fa-spin"></i> Loading
        </div>
        <div v-else>
            <vue-headful :title="'Complete Corrective Action :: MeritEHS'"/>

            <corrective-action-breadcrumbs :action="action" mode="Complete"></corrective-action-breadcrumbs>

            <div class="row">
                <div class="col-xl-9 col-lg-12">
                    <div class="card mb-4">
                        <div class="card-header"><strong>Completed Details</strong></div>
                        <div class="card-body">
                            <div class="form-group row">
                                <label class="col-md-3 col-sm-4 col-form-label text-sm-right">Status</label>
                                <div class="col-sm-8">
                                    <select v-model="action.status_id" class="form-control">
                                        <option v-for="(value, key) in statuses" v-bind:value="key">
                                            {{ value }}
                                        </option>
                                    </select>
                                    <span v-if="errors.status_id" class="text-danger">
                                        <span v-for="error in errors.status_id">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-md-3 col-sm-4 col-form-label text-sm-right" :class="{'text-danger': errors.completed_detail}">
                                    Completed Detail: <i class="fa fa-sm fa-asterisk text-danger"></i>
                                </label>
                                <div class="col-sm-8">
                                    <textarea v-model="action.completed_detail" class="form-control" :class="{'is-invalid': errors.completed_detail}" placeholder="Enter the Completed Details" style="min-height: 100px;"></textarea>
                                    <span v-if="errors.completed_detail" class="text-danger">
                                        <span v-for="error in errors.completed_detail">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                            <hr />

                            <div class="row mb-2">
                                <div class="col-lg-3 text-sm-right text-muted">Location:</div>
                                <div class="col-lg-9">
                                    {{ action.location }}
                                </div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-lg-3 text-sm-right text-muted">Detail:</div>
                                <div class="col-lg-9">
                                    {{ action.detail }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card">
                        <div class="card-header"><strong>Files (Optional)</strong></div>
                        <div class="card-body">
                            <file-uploader assetType="CorrectiveAction" :assetId="parseInt(corrective_action_id)" />
                        </div>
                    </div>
                </div>
            </div>
            <hr/>

            <button type="button" class="btn btn-sm btn-success" v-on:click="saveAction(this)" :disabled="saving">
                Complete Corrective Action
            </button>
        </div>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                loading: true,
                saving: false,
                corrective_action_id: this.$route.params.id,
                action: {},
                statuses: {},
                errors: {},
            }
        },

        methods: {
            //Get the Various Resources We Need to Edit a Corrective Action
            getErrorClass: function(attribute) {
                return {
                    'form-group has-error': this.errors[attribute],
                    'form-group': !this.errors[attribute],
                }
            },

            getAction: function() {
                //Get the data
                this.$http
                    .get(`corrective-actions/view/${this.corrective_action_id}?complete=true`)
                    .then(response => {
                        //Set all the data
                        this.action = response.data.action;
                        this.statuses = response.data.statuses;

                        //Set loading
                        this.loading = false;
                    })
                    .catch(response => {

                    });
            },

            saveAction: function() {
                //Show loading
                this.saving = true;

                //Reset the errors
                this.errors = {};

                //Send it
                this.$http
                .post(`corrective-actions/complete/${this.corrective_action_id}`, this.action)
                .then(response => {
                    //Alert the user?
                    this.$toastr.success('Corrective Action Completed');

                    //Return to main list?
                    this.$router.push('/corrective-actions/view/' + response.data.corrective_action_id);
                })
                .catch(error => {
                    //Check for error
                    if(error.response.status === 422)
                    {
                        //Display validation errors
                        this.errors = error.response.data
                    }
                })
                .then(response => {
                    //SHow loading
                    this.saving = false;
                });
            }
        },

        mounted() {
            //Get the incidents
            this.getAction();
        }
    }
</script>
